// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"79d0ebf6","453":"0cb6a2af","455":"0c8e8625","977":"6015c381"}[chunkId] + ".chunk.js";
};